import React, { useState, useEffect } from 'react';
import { db } from './firebaseConfig';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { toast } from 'react-toastify';

// Imports dos componentes MUI (com 'Grid' removido)
import {
  Box, Paper, Typography, TextField, InputAdornment, Button
} from '@mui/material';

const Tarifas = () => {
  const [tarifas, setTarifas] = useState({
    capacidade_4: { AABB_ARACAJU: 0, OUTRA_AABB: 0, NAO_ASSOCIADO: 0 },
    capacidade_5: { AABB_ARACAJU: 0, OUTRA_AABB: 0, NAO_ASSOCIADO: 0 }
  });
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    const fetchTarifas = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, 'tarifas', 'padrao');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const dataFromDb = docSnap.data();
          setTarifas(prev => ({
            capacidade_4: { ...prev.capacidade_4, ...dataFromDb.capacidade_4 },
            capacidade_5: { ...prev.capacidade_5, ...dataFromDb.capacidade_5 }
          }));
        } else {
          console.log("Documento de tarifas não encontrado!");
          toast.warn("Documento de tarifas não encontrado no banco de dados.");
        }
      } catch (error) {
        console.error("Erro ao buscar tarifas: ", error);
        toast.error("Erro ao carregar as tarifas.");
      } finally {
        setLoading(false);
      }
    };
    fetchTarifas();
  }, []);

  const handleChange = (capacidade, tipo, value) => {
    setTarifas(prev => ({
      ...prev,
      [capacidade]: {
        ...prev[capacidade],
        [tipo]: parseFloat(value) || 0
      }
    }));
  };

  const handleSave = async () => {
    setSalvando(true);
    try {
      const docRef = doc(db, 'tarifas', 'padrao');
      await updateDoc(docRef, tarifas);
      toast.success('Tarifas atualizadas com sucesso!');
    } catch (error) {
      console.error("Erro ao salvar tarifas: ", error);
      toast.error('Ocorreu um erro ao salvar as tarifas.');
    } finally {
      setSalvando(false);
    }
  };

  const TarifaInput = ({ capacidade, tipo, label }) => (
    <TextField
      label={label}
      type="number"
      fullWidth
      margin="normal"
      value={tarifas[capacidade][tipo]}
      onChange={e => handleChange(capacidade, tipo, e.target.value)}
      InputProps={{
        startAdornment: <InputAdornment position="start">R$</InputAdornment>,
      }}
    />
  );

  if (loading) {
    return <Typography sx={{ p: 3 }}>Carregando tarifas...</Typography>;
  }

  return (
    <Box sx={{ padding: 3, backgroundColor: 'background.default', minHeight: '100vh' }}>
      <Paper sx={{ padding: 3 }}>
        <Typography variant="h5" component="h1" fontWeight="600" gutterBottom>
          Gestão de Tarifas Padrão
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          Defina os valores das diárias para os diferentes tipos de chalés e hóspedes.
        </Typography>

        <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
          <Box sx={{ flex: 1, minWidth: '300px' }}>
            <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
              <Typography variant="h6" gutterBottom>Chalés para 4 Pessoas</Typography>
              <TarifaInput capacidade="capacidade_4" tipo="AABB_ARACAJU" label="Diária Associado AABB Aracaju" />
              <TarifaInput capacidade="capacidade_4" tipo="OUTRA_AABB" label="Diária Associado Outra AABB" />
              <TarifaInput capacidade="capacidade_4" tipo="NAO_ASSOCIADO" label="Diária Não Associado" />
            </Paper>
          </Box>

          <Box sx={{ flex: 1, minWidth: '300px' }}>
            <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
              <Typography variant="h6" gutterBottom>Chalés para 5 Pessoas (11 e 12)</Typography>
              <TarifaInput capacidade="capacidade_5" tipo="AABB_ARACAJU" label="Diária Associado AABB Aracaju" />
              <TarifaInput capacidade="capacidade_5" tipo="OUTRA_AABB" label="Diária Associado Outra AABB" />
              <TarifaInput capacidade="capacidade_5" tipo="NAO_ASSOCIADO" label="Diária Não Associado" />
            </Paper>
          </Box>
        </Box>

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          {/* Note que o LoadingButton foi removido no último passo, então não há mais a prop 'loading'.
              A lógica de 'salvando' pode ser usada para desabilitar o botão se desejado. */}
          <Button
            onClick={handleSave}
            disabled={salvando} // Usando o estado 'salvando' para desabilitar o botão
            variant="contained"
            size="large"
          >
            {salvando ? 'Salvando...' : 'Salvar Alterações'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Tarifas;